<template>
    <div>
        <el-table
            v-if="documents.length > 0"
            :data="documents"
            stripe
            :cellClassName="colorStep"
            :rowKey="rowKey"
            :expandRowKeys="expandRows"
            class="b-1 br rb-doc-listing"
            style="width: 100%"
            @expand-change="loadDocRelateds"
        >
            <el-table-column type="expand">
                <template #default="scope">
                    <rb-deadline-listing
                        v-if="scope.row.hasDeadlines"
                        :document="extractDoc(scope.row)"
                        :payments="scope.row.payments"
                        :deadlines="scope.row.deadlines"
                    />
                    <rb-payment-listing
                        v-else
                        :document="extractDoc(scope.row)"
                        :payments="scope.row.payments"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="thirdname" :label="$t.__('common.labels.name')" width="180">
            </el-table-column>
            <el-table-column :label="$t.__('common.labels.document_number')" width="180">
                <template #default="scope">
                    <a :href="scope.row.link" target="_blank">{{ scope.row.ident }}</a>
                </template>
            </el-table-column>
            <el-table-column :label="$t.__('common.labels.date')">
                <template #default="scope">
                    {{ $filters.saasDateFormatted(scope.row.displayedDate) }}
                </template>
            </el-table-column>
            <el-table-column
                prop="displayedStep"
                :label="$t.__('bankreconciliation.DocumentListing.document_status')"
            >
                <template #default="scope">
                    <component
                        v-bind="scope.row.displayedStep.params"
                        :is="scope.row.displayedStep.name"
                        :key="scope.row.displayedStep.params.id"
                    ></component>
                </template>
            </el-table-column>
            <el-table-column :label="$t.__('common.labels.amount_including_tax')">
                <template #default="scope">
                    {{ scope.row.formattedTotalAmount }}
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import PaymentListing from './PaymentListing.vue';
import DeadlineListing from './DeadlineListing.vue';
import TagStatus from 'vcomponents/common/TagStatus/TagStatus.vue';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters: reconciliationGetters } = createNamespacedHelpers('reconciliationStore');

export default {
    components: {
        'rb-payment-listing': PaymentListing,
        'rb-deadline-listing': DeadlineListing,
        TagStatus,
    },
    data() {
        return {
            paymentsLists: [],
            deadlinesLists: [],
            expandRows: [],
        };
    },
    computed: {
        ...reconciliationGetters(['docs', 'doctype']),
        documents() {
            return this.docs.map((doc) => {
                doc.payments = this.paymentsLists.filter((payment) => {
                    return doc.docid == payment.docid;
                });
                doc.deadlines = this.deadlinesLists.filter((deadline) => {
                    return doc.docid == deadline.docid;
                });
                return doc;
            });
        },
    },
    methods: {
        colorStep: function ({ row, column, rowIndex, columnIndex }) {
            if (columnIndex == 4) {
                return 'docstep-' + row.step + '-color';
            }
            return '';
        },
        rowKey: function (row) {
            return row.docid;
        },
        loadDocRelateds: function (row, expandedRows) {
            const doc = expandedRows.find((expandedDoc) => {
                return expandedDoc.docid == row.docid;
            });
            if (doc !== undefined) {
                if (doc.hasDeadlines) {
                    this.loadDeadlines(row.docid);
                }
                this.loadPayments(row.docid);
                this.expandRows.push(row.docid);
            } else {
                this.paymentsLists = this.paymentsLists.filter((payment) => {
                    return payment.docid != row.docid;
                });
                this.deadlinesLists = this.deadlinesLists.filter((deadline) => {
                    return deadline.docid != row.docid;
                });
                this.expandRows = this.expandRows.filter((expandRow) => {
                    return expandRow != row.docid;
                });
            }
        },
        loadPayments: function (docid) {
            const option = {
                reconciliation_doctype: this.doctype,
                reconciliation_docid: docid,
            };
            $.post(
                './?_f=bankreconciliation_reconciliation&action=getPaymentsForDoc',
                option,
                (data) => {
                    const payments = this.sortPayments(data.payments).map((payment) => {
                        payment.docid = docid;
                        return payment;
                    });
                    this.paymentsLists = this.paymentsLists.concat(payments);
                },
                'json',
            );
        },
        loadDeadlines: function (docid) {
            const option = {
                reconciliation_doctype: this.doctype,
                reconciliation_docid: docid,
            };
            $.post(
                './?_f=bankreconciliation_reconciliation&action=getDeadlinesForDoc',
                option,
                (data) => {
                    const deadlines = data.deadlines.map((deadline) => {
                        deadline.docid = docid;
                        return deadline;
                    });
                    this.deadlinesLists = this.deadlinesLists.concat(deadlines);
                },
                'json',
            );
        },
        sortPayments: function (payments) {
            if (!payments) {
                return [];
            }
            return payments.sort((a, b) => {
                if (a.isReconciled > b.isReconciled) {
                    return -1;
                } else if (a.isReconciled < b.isReconciled) {
                    return 1;
                }

                if (a.date > b.date) {
                    return 1;
                } else if (a.date < b.date) {
                    return -1;
                }
                return 0;
            });
        },
        extractDoc: function (row) {
            return {
                id: row.docid,
                type: this.doctype,
                step: row.step,
                link: row.link,
                ident: row.ident,
                dueAmount: row.dueAmount,
                thirdname: row.thirdname,
                totalAmount: row.totalAmount,
            };
        },
    },
};
</script>

<style lang="scss">
@use '~@sellsy/styleguide/src/_variables' as *;

.rb-doc-listing {
    .el-table__expanded-cell {
        border-left: 3px solid $primary-50;
    }
}
</style>
